// extracted by mini-css-extract-plugin
module.exports = {"surveyPage":"styles-module__surveyPage___3Nzke","surveySection":"styles-module__surveySection___y9cre","footer":"styles-module__footer___8NH2v"};